import { KeyInfoValues } from './AboutStock';
import { STOCK_SLUG_TYPE } from './types';
import { INDEX_SLUG_TYPE } from '../index-page/types';

export const NEW_CARAT_VALUES = ['18k', '14k', '12k', '9k'];
const FORBIDDEN_INTERVALS_FOR_NEW_CARATS = ['3M', '6M'];

export const getKeyInfoDetails = (
  stockDetails: STOCK_SLUG_TYPE
): KeyInfoValues => {
  const {
    REGADD1,
    REGADD2,
    REGDIST,
    REGPIN,
    FAX1,
    TEL1,
    REGSTATE,
    EMAIL,
    INTERNET,
  } = stockDetails.address;
  return {
    address: `${REGADD1 ? REGADD1 + ',' : ''} ${REGADD2 ? REGADD2 + ',' : ''} ${
      REGDIST ? REGDIST + ',' : ''
    } ${REGSTATE ? REGSTATE + ',' : ''} ${REGPIN ? REGPIN : ''}`,
    faxNo: FAX1,
    tellNo: TEL1,
    email: EMAIL,
    website: INTERNET,
  };
};

export const getIndexKeyInfoDetails = (
  stockDetails: INDEX_SLUG_TYPE
): KeyInfoValues => {
  const { founded_year, exchange, parent_organisation } = stockDetails;
  return {
    founded_year: founded_year,
    exchange: exchange,
    parent_organisation: parent_organisation,
  };
};

export const titleCaseFromSnake = (str: string): string => {
  return str
    .split('_')
    .map((word) => word[0]?.toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export type tableKeyPlaceHolderMappingType = {
  [key: string]: string;
};

export const getTablePlaceHolderSwitch = (
  key: string,
  tableMapping: tableKeyPlaceHolderMappingType
): unknown => {
  switch (key) {
    case key:
      if (key in tableMapping)
        return tableMapping[key as keyof tableKeyPlaceHolderMappingType];
      else return key;
    default:
      return key;
  }
};

export const onCaratChange = async ({
  carat,
  interval,
  city,
  setInterval,
  setGraphData,
  setChange,
  setPercentageChange,
  getGraphData,
}: {
  carat: string;
  interval: string;
  city: string;
  setInterval: React.Dispatch<React.SetStateAction<string>>;
  setGraphData: React.Dispatch<React.SetStateAction<number[][]>>;
  setChange: React.Dispatch<
    React.SetStateAction<{ change22k: number; change24k: number }>
  >;
  setPercentageChange: React.Dispatch<
    React.SetStateAction<{ change22k: number; change24k: number }>
  >;
  getGraphData: (
    city: string,
    interval: string,
    type: string
  ) => Promise<number[][]>;
}) => {
  try {
    if (
      NEW_CARAT_VALUES.includes(carat) &&
      FORBIDDEN_INTERVALS_FOR_NEW_CARATS.includes(interval)
    ) {
      setInterval(() => '1W');
    }
    const data = await getGraphData(city, interval, `gold${carat}`);

    setGraphData(data);

    const [changeDataForRateCard22k, changeDataForRateCard24k] = [
      await getGraphData(city, interval, `gold22k`),
      await getGraphData(city, interval, `gold24k`),
    ];

    if (
      changeDataForRateCard22k &&
      changeDataForRateCard24k &&
      changeDataForRateCard22k.length >= 2 &&
      changeDataForRateCard24k.length >= 2
    ) {
      //for 22k
      const initialRate22k = Number(changeDataForRateCard22k[0]?.[1] ?? 1);
      const finalRate22k = Number(
        changeDataForRateCard22k[changeDataForRateCard22k.length - 1]?.[1] ?? 0
      );
      const percentageChange22k = parseFloat(
        (((finalRate22k - initialRate22k) / initialRate22k) * 100).toFixed(2)
      );

      //for 24k
      const initialRate24k = Number(changeDataForRateCard24k[0]?.[1] ?? 1);
      const finalRate24k = Number(
        changeDataForRateCard24k[changeDataForRateCard24k.length - 1]?.[1] ?? 0
      );
      const percentageChange24k = parseFloat(
        (((finalRate24k - initialRate24k) / initialRate24k) * 100).toFixed(2)
      );

      setChange({
        change22k: finalRate22k - initialRate22k,
        change24k: finalRate24k - initialRate24k,
      });
      setPercentageChange({
        change22k: percentageChange22k,
        change24k: percentageChange24k,
      });
    }
  } catch (error) {
    console.error('Error fetching gold price data:', error);
  }
};
